import {useContext, useEffect, useState} from 'react'
import {setupAxios, useAuth} from '../../../modules/auth'
import axios from 'axios'
import {Col, Row} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {
  Message,
  changeTextCamal,
  checkRole,
  convertToAMPM,
  getDateYYYYMMDD,
} from '../../../../_metronic/helpers'
import {getUsersById, changeUserStatusApi} from '../../../../api/AdminAPI'
import FeatureGate from '../../../components/FeatureGate'
import {FEATURE_KEYS} from '../../../features/featureRegistry'
import {API_BASE_URL} from '../../../../utils/contants'
import Select2 from '../../../components/select2'
import roleContext from '../../../context/roleContext'
import {RoleContextValue} from '../../../types/OtherTypes'
import {handleInputChange} from '../../user/UserFunction'
import UserDetailsTable from './UserDetailsTable'
import {SelectItem} from '@mantine/core'
import {getDesignationData, getEmploymentTypeData} from '../../../CommonFunction'
import API from '../../../../api/APIUrl'
import {useParams} from 'react-router-dom'

const validateBankField = (field: string, rawValue: unknown): string => {
  const value = String(rawValue ?? '').trim()
  switch (field) {
    case 'bankName':
      if (!value) return 'Please enter a Bank Name.'
      if (value.length < 3 || value.length > 50 || !/^(?=.*[A-Za-z])[A-Za-z0-9 .,&'()/-]+$/.test(value)) return 'Bank Name must be 3–50 characters and contain letters.'
      return ''
    case 'branchName':
      if (value && (value.length < 2 || value.length > 100 || !/^(?=.*[A-Za-z])[A-Za-z0-9 .,&'()/-]+$/.test(value))) return 'Branch Name must be 2–100 characters and contain letters.'
      return ''
    case 'accountNumber':
      return /^[0-9]{9,18}$/.test(value) ? '' : 'Account Number must contain 9–18 digits.'
    case 'ifscCode':
      return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value.toUpperCase()) ? '' : 'Enter a valid 11-character IFSC code.'
    case 'panNumber':
      return /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value.toUpperCase()) ? '' : 'Enter a valid 10-character PAN number.'
    case 'aadharNumber':
      return /^[0-9]{12}$/.test(value) ? '' : 'Aadhaar number must contain exactly 12 digits.'
    default:
      return ''
  }
}

export function Overview({data, setUser}) {
  let roleState: RoleContextValue = useContext(roleContext)
  const {currentUser} = useAuth()
  const params = useParams()
  const paramUserId = params.id
  let bankData = data?.bankDetails?.map((item) => item)[0]

  // Check if current user can edit this profile
  const canEditProfile = () => {
    const effectiveRoleName = (currentUser?.role?.name || roleState.roleName || '')
      .trim()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .toUpperCase()

    // Cannot edit own profile
    if (currentUser?.id === (paramUserId || data?.id)) {
      return false
    }

    // Super Admin can edit all profiles
    const isAdmin = effectiveRoleName === 'ADMIN' || effectiveRoleName === 'SUPER ADMIN' || effectiveRoleName === 'SUPERADMIN'
    if (isAdmin) {
      return true
    }

    // Check if current user is an associate (HR or RM) of this user
    const isAssociate = data?.associates?.some((associate: any) =>
      ['HR', 'RM'].includes(associate.associateType) &&
      associate.userAssociate?.id === currentUser?.id
    )

    return isAssociate
  }
  const [aadharValidationError, setAadharValidationError] = useState('')
  const [panValidationError, setPanValidationError] = useState('')
  const [bankNameError, setBankNameError] = useState('')
  const [ifscValidationError, setIFSCValidationError] = useState('')
  const [accountNoValidationError, setAccountNoValidationError] = useState('')
  const [branchNameError, setBranchNameError] = useState('')
  const [reportingManagerError, setreportingManagerError] = useState('')
  const [employeeCodeError, setEmployeeCodeError] = useState('')
  const [firstNameError, setFirstNameError] = useState('')
  const [lastNameError, setLastNameError] = useState('')
  const [contactError, setContactError] = useState('')
  const [inTineError, setInTimeError] = useState('')
  const [outTimeError, setOutTimeError] = useState('')
  const [designationError, setDesignationError] = useState('')
  const [empolyementTypeError, setEmpolyementTypeError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [personalEmailError, setPersonalEmailError] = useState('')
  const [startDateError, setStartDateError] = useState('')
  const [endDateError, setEndDateError] = useState('')
  const [dobError, setDobError] = useState('')
  const [roleError, setRoleError] = useState('')
  const [genderError, setGenderError] = useState('')
  const [designation, setDesignation] = useState<SelectItem[]>([])
  const [employmentType, setEmploymentType] = useState<SelectItem[]>([])
  const [departments, setDepartments] = useState<{ value: string; label: string }[]>([]);

  const fetchUserById = () => {
    getUsersById(data.id)
      .then((userData) => setUser(userData.data))
      .catch((error) => {
        // Handle error silently or use proper error handling
      })
  }
   
  // ----------------------------
  // Fetch departments when component mounts
  // ----------------------------
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const { token } = setupAxios()
        const response = await axios.get(`${API_BASE_URL}/departments`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        if (Array.isArray(response.data)) {
          const deptData = response.data.map((dept: any) => ({
            label: dept.name,
            value: String(dept.id),
          }))
          setDepartments(deptData)
        }
      } catch (error) {
        console.error('Error fetching departments:', error)
      }
    }

    fetchDepartments()
  }, [])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      setUserId(data?.id)
      setPersonalDetailData({
        firstName: data.firstName,
        middleName: data.middleName || '',
        lastName: data.lastName,
        email: data.email,
        contact: data.mobile,
        dob: getDateYYYYMMDD(data.dateOfBirth),
        gender: data.gender,
        employeeCode: data?.employeeCode,
         departmentId: data?.department?.id ?? null,
        role: data?.userRoles?.map((item) => item.id)[0],
        hrManager: data.associates?.filter((item) => item.associateType === 'HR')[0]?.userAssociate
          ?.id,
        employmentType: data.employment?.id,
        designation: data.designation?.id,
        startDate: getDateYYYYMMDD(data.joiningDate),
        endDate: getDateYYYYMMDD(data.lastWorkingDate),
        inTime: data.inTime,
        outTime: data.outTime,
        reportingManager: data.associates?.filter((item) => item.associateType === 'RM')[0]
          ?.userAssociate?.id,
        personalEmail: data.personalEmail,
        address: data.address,
        permanentAddress: data?.permanentAddress || '',
        locationId: data?.location?.id || '',
        emergencyName: data?.emergencyName || '',
        //emergencyMobile: data?.emergencyMobile || '',
        emergencyMobile: data?.emergencyMobile || '',
        emergencyRelation: data?.emergencyRelation || '',
        isPoshCommitteeMember: data?.isPoshCommitteeMember ?? false,
      })
      setBankDetailData({
        bankName: bankData?.bankName,
        branchName: bankData?.branchName,
        accountNumber: bankData?.accountNumber,
        ifscCode: bankData?.ifscCode,
        panNumber: bankData?.panNumber,
        aadharNumber: bankData?.aadharNumber,
      })
      // fetchBand()
      }
    return () => {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlePersonalDataChange = (event, field?) => {
    if (field) {
      setPersonalDetailData((prevInputField) => ({
        ...prevInputField,
        [field]: event,
      }))
    } else if (event.target) {
      const {name, value} = event.target

      if (name === 'firstName') {
        const isValidFirstName = /^[A-Za-z.][A-Za-z. ]*$/.test(value)

        if (!isValidFirstName) {
          setFirstNameError('Please enter a valid First Name using only alphabetic characters.')
        } else if (value.length < 2) {
          setFirstNameError('First Name must be at least 2 characters.')
        } else if (value.length > 35) {
          setFirstNameError('First Name must not exceed 35 characters.')
        } else {
          setFirstNameError('')
        }
        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'lastName') {
        const isValidLastName = /^[A-Za-z.][A-Za-z. ]*$/.test(value)
        if (!isValidLastName) {
          setLastNameError('Please enter a valid Last Name using only alphabetic characters.')
        } else if (value.length < 2) {
          setLastNameError('Last Name must be at least 2 characters.')
        } else if (value.length > 35) {
          setLastNameError('Last Name must not exceed 35 characters.')
        } else {
          setLastNameError('')
        }
        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'contact') {
        const isValidContact = /^[0-9]+$/.test(value)

        if (!isValidContact) {
          setContactError('Please enter a valid Mobile Number using only numeric characters.')
        } else if (value.length > 10) {
          setContactError('Mobile Number must be exactly 10 digits.')
        } else {
          setContactError('')
        }
        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      }

      // if (name === 'email') {
      //   const isValidEmail = /@(skeletos\.in|skeletos\.io)$/.test(value)
      //   if (!isValidEmail) {
      //     setEmailError('Please enter a valid Organization Email.')
      //   } else {
      //     setEmailError('')
      //   }
      else if (name === 'email') {
        if (data.email) {
          const currentUserDomain = data.email.split('@')[1]
          const inputEmailDomain = value.split('@')[1]

          if (currentUserDomain !== inputEmailDomain) {
            setEmailError('Please enter a valid organization email domain.')
          } else {
            setEmailError('')
          }
        }

        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'personalEmail') {
        const isValidPersonalEmail = /@([a-z-_]{2,}\.com)$/.test(value)
        if (value) {
          if (!isValidPersonalEmail) {
            setPersonalEmailError('Please enter a valid Personal Email.')
          }
        } else {
          setPersonalEmailError('')
        }
        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'startDate') {
        if (!value) {
          setStartDateError('Please enter/select a Date of Joining')
        } else {
          setStartDateError('')
        }
        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'inTime') {
        if (!value) {
          setInTimeError('Please enter/select a In Time.')
        } else {
          setInTimeError('')
        }
        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'role') {
        if (!value) {
          setRoleError('Please enter/select a Role.')
        } else {
          setRoleError('')
        }
        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'outTime') {
        if (!value) {
          setOutTimeError('Please enter/select an Out Time.')
        } else {
          setOutTimeError('')

          const baseDate = new Date()
          const inTimeValue = data?.inTime ?? '-'
          const [inHours, inMinutes] = inTimeValue?.split(':') ?? '-'
          const [outHours, outMinutes] = value?.split(':') ?? '-'
          const inTime = new Date(baseDate)
          inTime.setHours(parseInt(inHours, 10), parseInt(inMinutes, 10), 0, 0)
          const outTime = new Date(baseDate)
          outTime.setHours(parseInt(outHours, 10), parseInt(outMinutes, 10), 0, 0)
          const maxHours = 10
          const minHours = 4
          let timeDifferenceInMilliseconds = outTime.getTime() - inTime.getTime()
          if (timeDifferenceInMilliseconds < 0) {
            timeDifferenceInMilliseconds += 24 * 60 * 60 * 1000
          }
          const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60)
          if (timeDifferenceInHours > maxHours) {
            setOutTimeError(
              "Please ensure that the 'Out Time' does not exceed 10 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
            )
          } else if (timeDifferenceInHours < minHours) {
            setOutTimeError(
              "Please ensure that the 'Out Time' must be at least 4 hours after the 'In Time', and Please adjust your 'In Time' and 'Out Time' accordingly."
            )
          }
        }

        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      } else if (name === 'dob') {
        if (!value) {
          setDobError('Please enter/select a Date of Birth.')
        } else {
          setDobError('')

          const dobDate = new Date(value)
          const currentDate = new Date()
          const minAge = 18

          // Calculate age
          const age =
            currentDate.getFullYear() -
            dobDate.getFullYear() -
            (currentDate.getMonth() < dobDate.getMonth() ||
            (currentDate.getMonth() === dobDate.getMonth() &&
              currentDate.getDate() < dobDate.getDate())
              ? 1
              : 0)

          if (age < minAge) {
            setDobError(`Users must be at least ${minAge} years old to register.`)
          }
        }

        setPersonalDetailData((prevInputField) => ({
          ...prevInputField,
          [name]: value,
        }))
      }

      setPersonalDetailData((prevInputField) => ({
        ...prevInputField,
        [name]: value,
      }))
    }
  }

  const handleBankDataChange = (event, field?) => {
    const name = field || event?.target?.name
    if (!name) return
    const rawValue = field ? event : event.target.value
    const value = name === 'panNumber' || name === 'ifscCode' ? String(rawValue).toUpperCase() : rawValue
    setBankDetailData((previous) => ({ ...previous, [name]: value }))
    const validationError = validateBankField(name, value)
    if (name === 'aadharNumber') setAadharValidationError(validationError)
    else if (name === 'panNumber') setPanValidationError(validationError)
    else if (name === 'bankName') setBankNameError(validationError)
    else if (name === 'ifscCode') setIFSCValidationError(validationError)
    else if (name === 'accountNumber') setAccountNoValidationError(validationError)
    else if (name === 'branchName') setBranchNameError(validationError)
  }

  // Reset the message state after a successful password update

  const [isPersonalDetailEdit, setPersonalDetailEdit] = useState(false)
  const [userNames, setUserNames] = useState<{label: string; value: string}[]>([])
  const sortedUserNames = userNames.slice().sort((a, b) => a.label.localeCompare(b.label))

  const fetchNames = () => {
    const {token} = setupAxios()
    axios
      .get(API_BASE_URL + `/users?preset=dropdown`, {
        headers: {
          Authorization: `Bearer ${token}`,
          // 'X-tenant-Id': `${tenantId}`,
        },
      })
      .then((response: any) => {
        let userData: {label: string; value: string}[] = []
        response.data.data?.forEach((obj: {firstName: string; lastName: string; id: string}) => {
          userData.push({
            label: obj.firstName + ' ' + obj.lastName,
            value: obj.id,
          })
        })
        setUserNames(userData)
      })
      .catch((error) => {
        // Handle error silently or use proper error handling
      })
  }
  const [roles, setRoles] = useState<{label: string; value: string}[]>([])
  const sortedRoles = roles.slice().sort((a, b) => a.label.localeCompare(b.label))

  const fetchRoles = () => {
    const {token} = setupAxios()
    axios
      .get(API_BASE_URL + `/roles`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response: any) => {
        let userData: {label: string; value: string}[] = []
        response.data.data?.forEach((obj: {name: string; id: string}) => {
          userData.push({
            label: obj.name + ' ',
            value: obj.id,
          })
        })
        setRoles(userData)
      })
      .catch((error) => {
        // Handle error silently or use proper error handling
      })
  }

  const handleEditProfileClick = () => {
    fetchNames()
    fetchRoles()
    getEmploymentTypeData(setEmploymentType)
    getDesignationData(setDesignation)
    // fetchHr()
    setPersonalDetailEdit(true)
    setPersonalDetailData(initialPersonalDetailData)
    setIsBankDetailEdit(false)
    // const reportingManagerId = data.reportingManager ? data.reportingManager.id : ''
    // setPersonalDetailData((prevInputField) => ({
    //   ...prevInputField,
    //   reportingManager: reportingManagerId,
    // }))
    // const roleId = data?.userRoles?.map((item) => item.id)[0]
    // setPersonalDetailData((prevInputField) => ({
    //   ...prevInputField,
    //   role: roleId,
    // }))
    // const hrId = data.hrManager ? data.hrManager.id : ''
    // setPersonalDetailData((prevInputField) => ({
    //   ...prevInputField,
    //   hrManager: hrId,
    // }))
  }

  const handleSaveProfile = async (updatedData: any) => {
    try {
      const {token} = setupAxios()
      
      // Create personal details payload
      const personalDetailsPayload = {
        employeeCode: updatedData.employeeCode,
        firstName: updatedData.firstName,
        middleName: updatedData.middleName || null,
        lastName: updatedData.lastName,
        email: updatedData.email,
        mobile: updatedData.mobile,
        gender: updatedData.gender,
        weekendDays: updatedData.weekendDays, //Weekend Days
        dateOfBirth: updatedData.dateOfBirth && updatedData.dateOfBirth.trim() ? updatedData.dateOfBirth : null,
        address: updatedData.address && updatedData.address.trim() ? updatedData.address : null,
        permanentAddress: updatedData.permanentAddress?.trim() || null,
        personalEmail: updatedData.personalEmail && updatedData.personalEmail.trim() ? updatedData.personalEmail : null,
        inTime: updatedData.inTime,
        outTime: updatedData.outTime,
        joiningDate: updatedData.joiningDate && updatedData.joiningDate.trim() ? updatedData.joiningDate : null,
        departmentId:
          updatedData.departmentId ??
          personalDetailData.departmentId ??
          data?.department?.id ??
          null,
        lastWorkingDate: updatedData.lastWorkingDate && updatedData.lastWorkingDate.trim() ? updatedData.lastWorkingDate : null,
        employmentTypeId: updatedData.employmentId || data.employment?.[0]?.employmentTypeId || data.userEmployments?.[0]?.employmentTypeId || data.employment?.id,
        designationId: updatedData.designationId || data.designationId || data.designation?.id,
        roleId: updatedData.roleId || data.userRoles?.[0]?.roleId || data.userRoles?.[0]?.role?.id || data.userRoles?.[0]?.id,
        hrId: updatedData.hrManagerId || data.associates?.find(assoc => assoc.associateType === 'HR')?.userAssociate?.id || null,
        rmId: updatedData.reportingManagerId || data.associates?.find(assoc => assoc.associateType === 'RM')?.userAssociate?.id || null,
        locationId: updatedData.locationId || null,
        emergencyName: updatedData.emergencyName || null,
        //emergencyMobile: updatedData.emergencyMobile || null,
        emergencyMobile: updatedData.emergencyMobile || null,
        emergencyRelation: updatedData.emergencyRelation || null,
        isPoshCommitteeMember: updatedData.isPoshCommitteeMember,
      }

      // Create bank details payload
      const bankDetailsPayload = {
        panNumber: updatedData.bankDetails.panNumber,
        aadharNumber: updatedData.bankDetails.aadharNumber,
        accountNumber: updatedData.bankDetails.accountNumber,
        ifscCode: updatedData.bankDetails.ifscCode,
        bankName: updatedData.bankDetails.bankName,
        branchName: updatedData.bankDetails.branchName && updatedData.bankDetails.branchName.trim() ? updatedData.bankDetails.branchName : null,
      }

      // Update personal details
      const personalResponse = await axios.put(
        `${API_BASE_URL}/users/${data.id}/personal`, 
        personalDetailsPayload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          }
        }
      )

      // Update bank details if there are values to update
      if (Object.values(bankDetailsPayload).some(value => value && value.trim() !== '')) {
        await axios.put(
          `${API_BASE_URL}/users/${data.id}/bank`, 
          bankDetailsPayload,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            }
          }
        )
      }

      if (personalResponse.data.statusCode === 200) {
        toast.success('Profile updated successfully!')
        if (personalResponse.data.data) {
          setUser(personalResponse.data.data)
        }
        fetchUserById()
      } else {
        toast.error('Failed to update profile')
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Error updating profile'
      toast.error(errorMessage)
    }
  }

  //Welcome@123 Password
  // const handleResetPassword = async () => {
  //   try {
  //     const {token} = setupAxios()
  //     const defaultPassword = 'Welcome@123'
      
  //     const response = await axios.put(`${API_BASE_URL}/users/${data.id}/change-password`, {
  //       password: defaultPassword
  //     }, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //       }
  //     })
      
  //     if (response.data.statusCode === 200) {
  //       toast.success(`Password reset successfully! New password: ${defaultPassword}`)
  //     } else {
  //       toast.error('Failed to reset password')
  //     }
  //   } catch (error: any) {
  //     const errorMessage = error.response?.data?.message || 'Error resetting password'
  //     toast.error(errorMessage)
  //   }
  // }

  //-------------------------------------------
  // New Code Added Auto Generated Password...
  const handleResetPassword = async () => {
  try {
    const {token} = setupAxios()

    const response = await axios.put(
      `${API_BASE_URL}/users/${data.id}/reset-password`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    )

    if (response.data.statusCode === 200) {
      toast.success('Password reset link sent to the user email.')
    } else {
      toast.error('Failed to reset password')
    }
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || 'Error resetting password'
    toast.error(errorMessage)
  }
}
//-------------------------------------------

  const resetPersonalDetail = () => {
    setPersonalDetailEdit(false)
    setFirstNameError('')
    setLastNameError('')
    setContactError('')
    setInTimeError('')
    setOutTimeError('')
    setDesignationError('')
    setEmpolyementTypeError('')
    setEmailError('')
    setRoleError('')
    setPersonalEmailError('')
    setStartDateError('')
    setEndDateError('')
    setDobError('')
    setreportingManagerError('')
    setGenderError('')
    setEmployeeCodeError('')
  }

  const initialPersonalDetailData = {
    firstName: data.firstName,
    middleName: data.middleName || '',
    lastName: data.lastName,
    email: data.email,
    contact: data.mobile,
    dob: getDateYYYYMMDD(data.dateOfBirth),
    gender: data.gender,
    role: data?.userRoles?.map((item) => item.id)[0],
    hrManager: data.associates?.filter((item) => item.associateType === 'HR')[0]?.userAssociate?.id,
    departmentId: data?.department?.id ?? null,
    employmentType: data.employment?.id,
    designation: data.designation?.id,
    startDate: getDateYYYYMMDD(data.joiningDate),
    endDate: getDateYYYYMMDD(data.lastWorkingDate),
    inTime: data.inTime,
    employeeCode: data?.employeeCode,
    outTime: data.outTime,
    reportingManager: data.associates?.filter((item) => item.associateType === 'RM')[0]
      ?.userAssociate?.id,
    personalEmail: data.personalEmail,
    address: data.address,
    permanentAddress: data.permanentAddress || '',
    locationId: data?.location?.id || '',
    emergencyName: data?.emergencyName || '',
    //emergencyMobile: data?.emergencyMobile || '',
    emergencyMobile: data?.emergencyMobile || '',
    emergencyRelation: data?.emergencyRelation || '',
    isPoshCommitteeMember: data?.isPoshCommitteeMember ?? false,
  }

  const [userId, setUserId] = useState(data?.id)

  const [personalDetailData, setPersonalDetailData] = useState(initialPersonalDetailData)

  const initialBankDetailData = {
    bankName: bankData?.bankName,
    branchName: bankData?.branchName,
    accountNumber: bankData?.accountNumber,
    ifscCode: bankData?.ifscCode,
    panNumber: bankData?.panNumber,
    aadharNumber: bankData?.aadharNumber,
  }
  const [bankDetailData, setBankDetailData] = useState(initialBankDetailData)

  // Update state when data prop changes
  useEffect(() => {
    if (data && data.id) {
      const updatedPersonalData = {
        firstName: data.firstName || '',
        middleName: data.middleName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        contact: data.mobile || '',
        dob: getDateYYYYMMDD(data.dateOfBirth),
        gender: data.gender || '',
        role: data?.userRoles?.map((item) => item.id)[0] || '',
        hrManager: data.associates?.filter((item) => item.associateType === 'HR')[0]?.userAssociate?.id || '',
        departmentId: data?.department?.id ?? null,
        employmentType: data.employment?.id || '',
        designation: data.designation?.id || '',
        startDate: getDateYYYYMMDD(data.joiningDate),
        endDate: getDateYYYYMMDD(data.lastWorkingDate),
        inTime: data.inTime || '',
        employeeCode: data?.employeeCode || '',
        outTime: data.outTime || '',
        reportingManager: data.associates?.filter((item) => item.associateType === 'RM')[0]?.userAssociate?.id || '',
        personalEmail: data.personalEmail || '',
        address: data.address || '',
        permanentAddress: data?.permanentAddress || '',
        locationId: data?.location?.id || '',
        emergencyName: data?.emergencyName || '',
        //emergencyMobile: data?.emergencyMobile || '',
        emergencyMobile: data?.emergencyMobile || '',
        emergencyRelation: data?.emergencyRelation || '',
        isPoshCommitteeMember: data?.isPoshCommitteeMember ?? false,
      }
      
      setPersonalDetailData(updatedPersonalData)
      setUserId(data.id)
      
      // Update bank data if available
      const firstBankDetail = data?.bankDetails?.[0]
      if (firstBankDetail) {
        const updatedBankData = {
          bankName: firstBankDetail.bankName || '',
          branchName: firstBankDetail.branchName || '',
          accountNumber: firstBankDetail.accountNumber || '',
          ifscCode: firstBankDetail.ifscCode || '',
          panNumber: firstBankDetail.panNumber || '',
          aadharNumber: firstBankDetail.aadharNumber || '',
        }
        setBankDetailData(updatedBankData)
      }
    }
  }, [data])

  //Weekend Day
  const weekendDays =
  Array.isArray(data?.weekendDays) && data.weekendDays.length > 0
    ? data.weekendDays
    : null

  const updatePersonalDetail = () => {
    const {token} = setupAxios()
    let error = 0
    if (!personalDetailData.firstName) {
      setFirstNameError('Please enter First Name.')
      error = error + 1
    } else {
      setFirstNameError('')
    }

    if (!personalDetailData.reportingManager) {
      setreportingManagerError('Please select/enter Reporting Manager.')
      error = error + 1
    } else {
      setreportingManagerError('')
    }

    if (!personalDetailData.dob) {
      setDobError('Please enter/select a Date of Birth.')
      error = error + 1
    } else {
      setDobError('')
    }

    if (!personalDetailData.lastName) {
      setLastNameError('Please enter Last Name.')
      error = error + 1
    } else {
      setLastNameError('')
    }
    if (!personalDetailData.role) {
      setRoleError('Please enter/select a Role.')
      error = error + 1
    } else {
      setRoleError('')
    }
    if (!personalDetailData.contact) {
      setContactError('Please enter a Mobile Number.')
      error = error + 1
    } else {
      setContactError('')
    }
    if (!personalDetailData.email) {
      setEmailError('Please enter a Organization Email.')
      error = error + 1
    } else {
      setEmailError('')
    }
    if (personalEmailError !== '') {
      error = error + 1
    } else {
      setPersonalEmailError('')
    }
    if (!personalDetailData.inTime) {
      setInTimeError('Please select/enter a InTime.')
      error = error + 1
    } else {
      setInTimeError('')
    }
    if (!personalDetailData.outTime) {
      setOutTimeError('Please select/enter a OutTime.')
      error = error + 1
    } else {
      setOutTimeError('')
    }

    if (!personalDetailData.designation) {
      setDesignationError('Please select/enter a Designtion.')
      error = error + 1
    } else {
      setDesignationError('')
    }

    if (!personalDetailData.employmentType) {
      setEmpolyementTypeError('Please select/enter a Employement Type.')
      error = error + 1
    } else {
      setEmpolyementTypeError('')
    }
    if (!personalDetailData.employeeCode) {
      setEmployeeCodeError('Please enter an Employee Code.')
      error = error + 1
    } else {
      // Validate employee code format (e.g., CTR-1111)
      const employeeCodeRegex = /^[A-Z]{3}-[0-9]{4}$/
      if (!employeeCodeRegex.test(personalDetailData.employeeCode.trim())) {
        setEmployeeCodeError('Employee code must follow format CTR-1111 (3 uppercase letters, hyphen, 4 digits).')
        error = error + 1
      } else {
        setEmployeeCodeError('')
      }
    }
    if (!personalDetailData.startDate) {
      setStartDateError('Please select/enter a Date Of Joining.')
      error = error + 1
    } else {
      setStartDateError('')
    }

    if (!personalDetailData.gender) {
      setGenderError('Please select a Gender.')
      error = error + 1
    } else {
      setGenderError('')
    }

    // if (!personalDetailData.band) {
    //   setBandError('Please add a Band.')
    //   error = error + 1
    // } else if (genderError !== '') {
    //   error = error + 1
    // } else {
    //   setBandError('')
    // }
    if (error === 0) {
      console.log("personalDetailData", personalDetailData);
      console.log("Middle Name:", personalDetailData.middleName);
      console.log("Payload:", {
        firstName: personalDetailData.firstName,
        middleName: personalDetailData.middleName,
        lastName: personalDetailData.lastName,
      });
      fetch(`${API_BASE_URL}/users/${userId}/personal`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${currentUser?.token}`,
        },
        method: 'PUT',
        body: JSON.stringify({
          firstName: personalDetailData.firstName.trim(),
          middleName: personalDetailData.middleName || null,
          lastName: personalDetailData.lastName.trim(),
          email: personalDetailData.email,
          mobile: personalDetailData.contact,
          dateOfBirth: personalDetailData.dob,
          gender: personalDetailData.gender,
          emergencyName: personalDetailData.emergencyName,
          //emergencyMobile: personalDetailData.emergencyMobile,
          emergencyMobile: personalDetailData.emergencyMobile,
          emergencyRelation: personalDetailData.emergencyRelation,
          roleId: personalDetailData.role.toString(),
          hrId: personalDetailData.hrManager ? personalDetailData.hrManager : null,
          rmId: !personalDetailData.reportingManager ? null : personalDetailData.reportingManager,
          departmentId: personalDetailData.departmentId?? null,   // ✅ REQUIRED
          employmentTypeId: personalDetailData.employmentType,
          designationId: personalDetailData.designation,
          joiningDate: personalDetailData.startDate,
          lastWorkingDate: !personalDetailData.endDate ? null : personalDetailData.endDate || null,
          inTime: personalDetailData.inTime,
          address: !personalDetailData?.address ? null : personalDetailData.address,
          permanentAddress: personalDetailData.permanentAddress?.trim() || null,
          locationId: personalDetailData.locationId || null,
          outTime: personalDetailData.outTime,
          employeeCode: personalDetailData?.employeeCode,
          isPoshCommitteeMember: personalDetailData.isPoshCommitteeMember,
          personalEmail: !personalDetailData?.personalEmail
            ? null
            : personalDetailData.personalEmail,
        }),
      }).then(async (res) => {
        let response = await res.json()
        if (response.statusCode === 200) {
          setUser(response.data)
          toast.success('User details updated successfully.')
          // setPersonalDetailData(response.data)
          setPersonalDetailEdit(false)
          fetchUserById()
          setTimeout(() => {
            resetPersonalDetail()
          }, 1000)
        } else {
          Message(response.message, 'error')
        }
      })
    }
  }

  // for bank details:update
  const [isBankDetailEdit, setIsBankDetailEdit] = useState(false)

  const handleBankDetailEdit = () => {
    // fetchNames()
    setIsBankDetailEdit(true)
    setBankDetailData(initialBankDetailData)
    setPersonalDetailEdit(false)
    setAadharValidationError('')
    setPanValidationError('')
    setIFSCValidationError('')
    setAccountNoValidationError('')
    setBranchNameError('')
    setBankNameError('')
  }

  const resetBankDetail = () => {
    setIsBankDetailEdit(false)
    setAadharValidationError('')
    setPanValidationError('')
    setIFSCValidationError('')
    setAccountNoValidationError('')
    setBranchNameError('')
    setBankNameError('')
  }

  const updateBankDetail = () => {
    const validationErrors = {
      bankName: validateBankField('bankName', bankDetailData.bankName),
      branchName: validateBankField('branchName', bankDetailData.branchName),
      accountNumber: validateBankField('accountNumber', bankDetailData.accountNumber),
      ifscCode: validateBankField('ifscCode', bankDetailData.ifscCode),
      panNumber: validateBankField('panNumber', bankDetailData.panNumber),
      aadharNumber: validateBankField('aadharNumber', bankDetailData.aadharNumber),
    }
    setBankNameError(validationErrors.bankName)
    setBranchNameError(validationErrors.branchName)
    setAccountNoValidationError(validationErrors.accountNumber)
    setIFSCValidationError(validationErrors.ifscCode)
    setPanValidationError(validationErrors.panNumber)
    setAadharValidationError(validationErrors.aadharNumber)

    if (Object.values(validationErrors).every((error) => !error)) {
      fetch(`${API_BASE_URL}/${API.USER}/${userId}/bank`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${currentUser?.token}`,
          // 'X-tenant-Id': `${currentUser?.tenantId}`,
        },
        body: JSON.stringify({
          ...bankDetailData,
          branchName: !bankDetailData?.branchName ? null : bankDetailData?.branchName,
        }),
      })
        .then(async (res) => {
          let response = await res?.json()
          if (response.statusCode === 200) {
            // setBankDetailData(response.data.data)
            toast.success('Bank details updated successfully.')
            setIsBankDetailEdit(false)
            fetchUserById()
            setTimeout(() => {
              resetBankDetail()
            }, 1000)
          }
          return response
        })
        .then((response) => {
          if (response.statusCode !== 200) {
            toast.error(response.message || 'Failed to update bank details.')
          }
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || 'Failed to update bank details.')
        })
    }
  }
  useEffect(() => {
    setUserId(data?.id)
    setPersonalDetailData({
      firstName: data.firstName,
      middleName: data.middleName || null,
      lastName: data.lastName,
      email: data.email,
      contact: data.mobile,
      dob: getDateYYYYMMDD(data.dateOfBirth),
      gender: data.gender,
      employeeCode: data?.employeeCode,
      departmentId: data?.department?.id ?? null,
      role: data?.userRoles?.map((item) => item.id)[0],
      hrManager: data.associates?.filter((item) => item.associateType === 'HR')[0]?.userAssociate
        ?.id,
      employmentType: data.employment?.id,
      designation: data.designation,
      startDate: getDateYYYYMMDD(data.joiningDate),
      endDate: getDateYYYYMMDD(data.lastWorkingDate),
      inTime: data.inTime,
      outTime: data.outTime,
      reportingManager: data.associates?.filter((item) => item.associateType === 'RM')[0]
        ?.userAssociate?.id,
      personalEmail: data.personalEmail,
      address: data.address,
      permanentAddress: data?.permanentAddress || '',
      locationId: data?.location?.id || '',
      emergencyName: data?.emergencyName || '',
      //emergencyMobile: data?.emergencyContactNumber || '',
      emergencyMobile: data?.emergencyMobile || '',
      emergencyRelation: data?.emergencyRelation || '',
      isPoshCommitteeMember: data?.isPoshCommitteeMember ?? false,
    })
    setBankDetailData({
      bankName: bankData?.bankName,
      branchName: bankData?.branchName,
      accountNumber: bankData?.accountNumber,
      ifscCode: bankData?.ifscCode,
      panNumber: bankData?.panNumber,
      aadharNumber: bankData?.aadharNumber,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <>
      {/* User Details Table - New Improved UI */}
      <UserDetailsTable 
        data={data} 
        //------------
        //Edit Details Button access only supreadmin & admin
        // canEdit={
        //   (roleState.roleName === 'Super Admin' || roleState.roleName === 'Admin')
        // }
        //--------------
        canEdit={canEditProfile()}
        visibleSections={{
          personal: checkRole(['user_personal_details_view'], roleState.features),
          work: checkRole(['user_work_details_view'], roleState.features) ?? true,
          management: checkRole(['user_management_details_view'], roleState.features) ?? true,
          bank: checkRole(['bank_details_view'], roleState.features)
        }}
        onSave={async (payload: any) => {
          if (payload?.status) {
            const target = payload.status === 'Inactive' ? 'deactivate' : 'reactivate'
            const confirmed = window.confirm(`Are you sure you want to ${target} this user?`)
            if (!confirmed) return
            const res = await changeUserStatusApi(data?.id, payload.status)
            if (res?.statusCode === 200) {
              toast.success(payload.status === 'Active' ? 'User reactivated successfully' : 'User marked as inactive successfully')
              setUser((prev: any) => ({...prev, status: payload.status}))
            } else {
              toast.error(res?.message || 'Failed to update status')
            }
            return
          }
          handleSaveProfile(payload)
        }}
        onResetPassword={handleResetPassword}
      />

      {/* Personal Details - Only show in edit mode (forms) */}
      <FeatureGate feature={FEATURE_KEYS.profile_personal_info}>
      <div
        className='card mb-5 mb-xl-10'
        id='kt_profile_details_view'
        hidden={!isPersonalDetailEdit}
      >
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Personal Details</h3>
          </div>

          <div
            className='card-toolbar'
            hidden={
              !canEditProfile() ||
              data?.status === 'Inactive'
            }
          >
            <i
              className='far fa-edit cursor-pointer'
              onClick={handleEditProfileClick}
            ></i>
          </div>
        </div>

        <div className='card-body p-9'>
          {/* fname nd lname */}
          {!isPersonalDetailEdit ? (
            <>
              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>First Name</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {changeTextCamal(data?.firstName)}{' '}
                  </span>
                </Col>

                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Last Name</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {changeTextCamal(data?.lastName)}{' '}
                  </span>
                </Col>
              </Row>
              {/* contact email */}

              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Mobile Number</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'> {data?.mobile ?? '-'} </span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Designation</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {changeTextCamal(data?.designation?.name)}{' '}
                  </span>
                </Col>
              </Row>

              {/* role employ type */}
              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Organization Email</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'> {data?.email ?? '-'} </span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Personal Email</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'> {data?.personalEmail ?? '-'}</span>
                </Col>
              </Row>
               {/* <-- Add Department dropdown here --> */}
            <Row className='mb-4'>
              <Col md={2}>
                <label className='required fw-bold fs-6 text-muted'>Department</label>
              </Col>
              <Col md={3}>
                <Select2
              name='departmentId'
              data={departments}
              value={personalDetailData?.departmentId}   // ✅ ID ONLY
              onChange={(e: any) =>
                handlePersonalDataChange(e, 'departmentId')
              }
            />


              </Col>
            </Row>
              {/* reporting manager */}

              <Row className='mb-4'>
                <Col md={2}>
                  <label className='fw-bold fs-6 text-muted'>Reporting Manager</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {data?.associates?.some((item) => item.associateType === 'RM')
                      ? data?.associates?.map((associate) =>
                          associate.associateType === 'RM' ? (
                            <>
                              {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
                              {changeTextCamal(associate?.userAssociate?.lastName)}
                            </>
                          ) : (
                            ''
                          )
                        )
                      : '-'}
                  </span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Employment Type </label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {changeTextCamal(data?.employment?.name ?? '-')}
                  </span>
                </Col>
              </Row>

              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Date of Joining</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {' '}
                    {getDateYYYYMMDD(data?.joiningDate) ?? '-'}
                  </span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Date Of Leaving</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {' '}
                    {getDateYYYYMMDD(data?.lastWorkingDate) ?? '-'}{' '}
                  </span>
                </Col>
              </Row>

              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>DOB</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {' '}
                    {getDateYYYYMMDD(data?.dateOfBirth ?? '') ?? '-'}{' '}
                  </span>
                </Col>
                <Col md={1}></Col>

                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Gender</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'> {changeTextCamal(data?.gender)}</span>
                </Col>
              </Row>
              {/* in/out time */}

              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>In Time</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {convertToAMPM(data?.inTime) ?? '-'}
                  </span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Out Time</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {convertToAMPM(data?.outTime) ?? '-'}
                  </span>
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='fw-bold fs-6 text-muted'>Weekend Days</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {weekendDays ? weekendDays.join(', ') : 'N/A'}
                  </span>
                </Col>
              </Row>


              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Role</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {data?.userRoles?.map((item) => item?.name)}
                  </span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Hr Manager</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>
                    {data?.associates?.some((item) => item.associateType === 'HR')
                      ? data?.associates?.map((associate) =>
                          associate.associateType === 'HR' ? (
                            <>
                              {changeTextCamal(associate?.userAssociate?.firstName)}{' '}
                              {changeTextCamal(associate?.userAssociate?.lastName)}
                            </>
                          ) : (
                            ''
                          )
                        )
                      : '-'}
                  </span>
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Employee Code</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>{data?.employeeCode}</span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Address</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>{data?.address}</span>
                </Col>
              </Row>
              {/* <Row className='mb-4'>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Band</label>
                </Col>
                <Col md={3}>
                  <span className='fw-bolder fs-6 text-dark'>{data?.band?.bandName}</span>
                </Col>
              </Row> */}
            </>
          ) : null}

          {isPersonalDetailEdit ? (
            <>
              {/* fname nd lname */}
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>First Name</label>
                </Col>
                <Col md={3}>
                  <span className='fs-6 text-dark'>
                    <input
                      type='text'
                      className={` required form-control ${firstNameError ? 'is-invalid' : ''}`}
                      name='firstName'
                      value={personalDetailData?.firstName}
                      onChange={(e) => {
                        handlePersonalDataChange(e)
                      }}
                    />
                    {firstNameError && <div className='invalid-feedback'>{firstNameError}</div>}
                  </span>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Last Name</label>
                </Col>
                <Col md={3}>
                  <input
                    type='text'
                    name='lastName'
                    className={` required form-control ${lastNameError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.lastName}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />
                  {lastNameError && <div className='invalid-feedback'>{lastNameError}</div>}
                </Col>
              </Row>
              {/* contact email */}
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Mobile Number</label>
                </Col>
                <Col md={3}>
                  <input
                    type='tel'
                    name='contact'
                    className={` required form-control ${contactError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.contact}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />
                  {contactError && <div className='invalid-feedback'>{contactError}</div>}
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Designation</label>
                </Col>
                <Col md={3}>
                  <Select2
                    name='designation'
                    // error={designationError}
                    className={`${designationError ? 'is-invalid' : ''}`}
                    data={designation}
                    value={personalDetailData?.designation}
                    onChange={(e: any) => {
                      handlePersonalDataChange(e, 'designation')
                    }}
                  />
                  {designationError && <div className='invalid-feedback'>{designationError}</div>}
                </Col>
              </Row>
              {/* role employ type */}
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Organization Email</label>
                </Col>
                <Col md={3}>
                  <input
                    type='text'
                    name='email'
                    className={` required form-control ${emailError ? 'is-invalid' : ''}`}
                    placeholder='XXX@skeletos.in/io'
                    value={personalDetailData?.email}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />
                  {emailError && <div className='invalid-feedback'>{emailError}</div>}
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className='fw-bold fs-6 text-muted'>Personal Email</label>
                </Col>
                <Col md={3}>
                  <input
                    type='text'
                    name='personalEmail'
                    className={` form-control ${personalEmailError ? 'is-invalid' : ''}`}
                    placeholder='XXX@gmail.com'
                    value={personalDetailData?.personalEmail}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />
                  {personalEmailError && (
                    <div className='invalid-feedback'>{personalEmailError}</div>
                  )}
                </Col>
              </Row>
              {/* reporting manager */}
              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' required fw-bold fs-6 text-muted'>Reporting Manager</label>
                </Col>
                <Col md={3}>
                  <Select2
                    name='reportingManager'
                    data={sortedUserNames}
                    value={personalDetailData?.reportingManager}
                    onChange={(e: any) => {
                      handlePersonalDataChange(e, 'reportingManager')
                    }}
                    // error={reportingManagerError}
                    className={` ${reportingManagerError ? 'is-invalid' : ''}`}
                  />
                  {reportingManagerError && (
                    <div className='invalid-feedback'>{reportingManagerError}</div>
                  )}
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Employement Type </label>
                </Col>
                <Col md={3}>
                  <Select2
                    name='employmentType'
                    className={`${empolyementTypeError ? 'is-invalid' : ''}`}
                    data={employmentType}
                    value={personalDetailData?.employmentType}
                    onChange={(e: any) => {
                      handlePersonalDataChange(e, 'employmentType')
                    }}
                  />
                  {empolyementTypeError && (
                    <div className='invalid-feedback'>{empolyementTypeError}</div>
                  )}
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Date of Joining</label>
                </Col>
                <Col md={3}>
                  <input
                    type='date'
                    name='startDate'
                    className={` form-control ${startDateError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.startDate}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />
                  {startDateError && <div className='invalid-feedback'>{startDateError}</div>}
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Date Of Leaving</label>
                </Col>
                <Col md={3}>
                  <input
                    type='date'
                    name='endDate'
                    className={` form-control ${endDateError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.endDate ?? ''}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />{' '}
                  {/* {endDateError && <div className='invalid-feedback'>{endDateError}</div>} */}
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>DOB</label>
                </Col>
                <Col md={3}>
                  <input
                    type='date'
                    name='dob'
                    className={` form-control ${dobError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.dob}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />{' '}
                  {dobError && <div className='invalid-feedback'>{dobError}</div>}
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Gender</label>
                </Col>
                <Col md={3}>
                  <div
                    // className='d-flex mt-2'
                    className={` d-flex mt-2  ${genderError ? 'is-invalid' : ''}`}
                  >
                    <div className='form-check'>
                      <input
                        className='form-check-input'
                        type='radio'
                        id='male'
                        name='gender'
                        value='male'
                        checked={personalDetailData?.gender === 'male'}
                        onChange={(e) => {
                          handlePersonalDataChange(e)
                        }}
                      />
                      {/* {genderError && <div className='invalid-feedback'>{genderError}</div>} */}

                      <label htmlFor='true' className='fw-bold text-gray-800 d-block me-3'>
                        Male
                      </label>
                    </div>
                    <div className='form-check' style={{paddingRight: '20px'}}>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='gender'
                        placeholder='radio1'
                        value='female'
                        id='female'
                        checked={personalDetailData?.gender === 'female'}
                        onChange={(e) => {
                          handlePersonalDataChange(e)
                        }}
                      />
                      <label htmlFor='false' className=' fw-bold text-gray-800 d-block'>
                        Female
                      </label>
                    </div>
                  </div>
                  {genderError && <div className='invalid-feedback'>{genderError}</div>}
                </Col>
              </Row>
              {/* in/out time */}
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>In Time</label>
                </Col>
                <Col md={3}>
                  <input
                    type='time'
                    name='inTime'
                    className={` form-control ${inTineError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.inTime}
                    onChange={(event) =>
                      handleInputChange(event, setPersonalDetailData, personalDetailData)
                    }
                  />
                  {inTineError && <div className='invalid-feedback'>{inTineError}</div>}
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Out Time</label>
                </Col>
                <Col md={3}>
                  <input
                    type='time'
                    name='outTime'
                    className={` form-control ${outTimeError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.outTime}
                    onChange={(event) =>
                      handleInputChange(event, setPersonalDetailData, personalDetailData)
                    }
                  />
                  {outTimeError && <div className='invalid-feedback'>{outTimeError}</div>}
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={2}>
                  <label className=' required fw-bold fs-6 text-muted'>Role</label>
                </Col>
                <Col md={3}>
                  <Select2
                    name='role'
                    data={sortedRoles}
                    className={`${roleError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.role}
                    onChange={(e: any) => {
                      handlePersonalDataChange(e, 'role')
                    }}
                  />
                  {roleError && <div className='invalid-feedback'>{roleError}</div>}
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className='fw-bold fs-6 text-muted'>Hr manager</label>
                </Col>
                <Col md={3}>
                  <Select2
                    name='hrManager'
                    data={sortedUserNames}
                    value={personalDetailData?.hrManager}
                    onChange={(e: any) => {
                      handlePersonalDataChange(e, 'hrManager')
                    }}
                  />
                  {reportingManagerError && (
                    <div className='invalid-feedback'>{reportingManagerError}</div>
                  )}
                </Col>
              </Row>
              <Row className='mb-4'>
                <Col md={2}>
                  <label className='required fw-bold fs-6 text-muted'>Employee Code</label>
                </Col>
                <Col md={3}>
                  <input
                    type='text'
                    name='employeeCode'
                    placeholder='CTR-1111'
                    className={` form-control ${employeeCodeError ? 'is-invalid' : ''}`}
                    value={personalDetailData?.employeeCode}
                    onChange={(event) =>
                      handleInputChange(event, setPersonalDetailData, personalDetailData)
                    }
                  />
                  {employeeCodeError && <div className='invalid-feedback'>{employeeCodeError}</div>}
                  <div className='text-muted fs-7'>
                    Format: CTR-1111 (3 letters, hyphen, 4 digits). Code should be same as biometric employee code
                  </div>
                </Col>
                <Col md={1}></Col>
                <Col md={2}>
                  <label className=' fw-bold fs-6 text-muted'>Address</label>
                </Col>
                <Col md={3}>
                  <input
                    type='text'
                    name='address'
                    className={`  form-control`}
                    value={personalDetailData?.address}
                    onChange={(e) => {
                      handlePersonalDataChange(e)
                    }}
                  />
                  {/* {lastNameError && <div className='invalid-feedback'>{lastNameError}</div>} */}
                </Col>
              </Row>
            </>
          ) : null}

          {isPersonalDetailEdit && (
            <div className='row mb-3'>
              <div className='col-md-12 mt-4 d-flex justify-content-end'>
                <div>
                  <button
                    className='btn btn-sm btn-secondary align-self-center me-2'
                    onClick={resetPersonalDetail}
                  >
                    Cancel
                  </button>
                  <button
                    className='btn btn-sm btn-primary align-self-center'
                    onClick={updatePersonalDetail}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      </FeatureGate>

      <FeatureGate feature={FEATURE_KEYS.profile_bank_info}>
      <div
        className='card mb-5 mb-xl-10'
        id='kt_profile_details_view'
      >
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Bank Details</h3>
          </div>

          <div
            className='card-toolbar'
            hidden={
              !canEditProfile() ||
              data?.status === 'Inactive'
            }
          >
            <i className='far fa-edit cursor-pointer' onClick={handleBankDetailEdit}></i>
          </div>
        </div>

        {!isBankDetailEdit ? (
          <div className='card-body p-9'>
            {/* Bank Name */}
            <Row className='mb-4'>
              <Col md={3}>
                <label className=' fw-bold fs-6 text-muted'>Bank Name</label>
              </Col>
              <Col md={2}>
                <span className='fw-bolder fs-6 text-dark'>{bankData?.bankName ?? '-'}</span>
              </Col>
              <Col md={1}></Col>
              <Col md={3}>
                <label className=' fw-bold fs-6 text-muted'>Branch Name</label>
              </Col>
              <Col md={2}>
                <span className='fw-bolder fs-6 text-dark'>{bankData?.branchName ?? '-'}</span>
              </Col>
            </Row>
            {/* Accountnumber*/}

            <Row className='mb-4'>
              <Col md={3}>
                <label className=' fw-bold fs-6 text-muted'>Account Number</label>
              </Col>
              <Col md={2}>
                <span className='fw-bolder fs-6 text-dark'> {bankData?.accountNumber ?? '-'} </span>
              </Col>
              <Col md={1}></Col>
              {/* Aadhar number */}

              <Col md={3}>
                <label className=' fw-bold fs-6 text-muted'>IFSC Code</label>
              </Col>
              <Col md={2}>
                <span className='fw-bolder fs-6 text-dark'> {bankData?.ifscCode ?? '-'} </span>
              </Col>
            </Row>

            {/* Pan number */}
            <Row className='mb-4'>
              <Col md={3}>
                <label className=' fw-bold fs-6 text-muted'>Pan Card Number</label>
              </Col>
              <Col md={2}>
                <span className='fw-bolder fs-6 text-dark'> {bankData?.panNumber ?? '-'} </span>
              </Col>
              <Col md={1}></Col>
              <Col md={3}>
                <label className=' fw-bold fs-6 text-muted'>Aadhar Card Number</label>
              </Col>
              <Col md={2}>
                <span className='fw-bolder fs-6 text-dark'> {bankData?.aadharNumber ?? '-'} </span>
              </Col>
            </Row>
          </div>
        ) : (
          <div className='card-body p-9'>
            {/* Bank Name */}
            <Row className='mb-4'>
              <Col md={3}>
                <label className='required fw-bold fs-6 text-muted'>Bank Name</label>
              </Col>
              <Col md={2}>
                <input
                  type='text'
                  name='bankName'
                  className={` required form-control ${bankNameError ? 'is-invalid' : ''}`}
                  value={bankDetailData?.bankName}
                  onChange={(e) => {
                    handleBankDataChange(e)
                  }}
                />
                {bankNameError && <div className='invalid-feedback'>{bankNameError}</div>}
              </Col>
              <Col md={1}></Col>
              <Col md={3}>
                <label className=' fw-bold fs-6 text-muted'>Branch Name</label>
              </Col>
              <Col md={2}>
                <input
                  type='text'
                  name='branchName'
                  className={` form-control ${branchNameError ? 'is-invalid' : ''}`}
                  value={bankDetailData?.branchName}
                  onChange={(e) => {
                    handleBankDataChange(e)
                  }}
                />
                {branchNameError && <div className='invalid-feedback'>{branchNameError}</div>}
              </Col>
            </Row>
            {/* Accountnumber*/}

            <Row className='mb-4'>
              <Col md={3}>
                <label className='required fw-bold fs-6 text-muted'>Account Number</label>
              </Col>
              <Col md={2}>
                <input
                  type='text'
                  inputMode='numeric'
                  maxLength={18}
                  name='accountNumber'
                  className={` required form-control ${
                    accountNoValidationError ? 'is-invalid' : ''
                  }`}
                  value={bankDetailData?.accountNumber}
                  onChange={(e) => handleBankDataChange(e)}
                />
                {accountNoValidationError && (
                  <div className='invalid-feedback'>{accountNoValidationError}</div>
                )}
              </Col>
              <Col md={1}></Col>
              {/* Aadhar number */}

              <Col md={3}>
                <label className='required fw-bold fs-6 text-muted'>IFSC Code</label>
              </Col>
              <Col md={2}>
                <input
                  type='text'
                  name='ifscCode'
                  className={`form-control ${ifscValidationError ? 'is-invalid' : ''}`}
                  value={bankDetailData?.ifscCode}
                  onChange={(e) => handleBankDataChange(e)}
                  maxLength={11}
                  pattern='/^[A-Z]{4}0[A-Z0-9]{6}$/'
                  placeholder='ABCD0123456'
                  required
                />
                {ifscValidationError && (
                  <div className='invalid-feedback'>{ifscValidationError}</div>
                )}
              </Col>
            </Row>

            {/* Pan number */}
            <Row className='mb-4'>
              <Col md={3}>
                <label className='required fw-bold fs-6 text-muted'>Pan Card Number</label>
              </Col>
              <Col md={2}>
                <input
                  type='text'
                  name='panNumber'
                  className={`form-control ${panValidationError ? 'is-invalid' : ''}`}
                  value={bankDetailData?.panNumber}
                  onChange={(e) => handleBankDataChange(e)}
                  maxLength={10}
                  pattern='/^[A-Z]{5}\d{4}[A-Z]$/'
                  placeholder='XXXXX1234X'
                  required
                />
                {panValidationError && <div className='invalid-feedback'>{panValidationError}</div>}
              </Col>
              <Col md={1}></Col>

              <Col md={3}>
                <label className='required fw-bold fs-6 text-muted'>Aadhaar Card Number</label>
              </Col>
              <Col md={2}>
                <input
                  type='text'
                  name='aadharNumber'
                  className={` required form-control ${aadharValidationError ? 'is-invalid' : ''}`}
                  value={bankDetailData?.aadharNumber}
                  onChange={(e) => handleBankDataChange(e)}
                  maxLength={12}
                  pattern='/^[2-9]{1}[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}$/'
                  placeholder='xxxx xxxx xxxx'
                  required
                />
                {aadharValidationError && (
                  <div className='invalid-feedback'>{aadharValidationError}</div>
                )}
              </Col>
            </Row>

            <div className='row mb-3'>
              <div className='col-md-12 mt-4 d-flex justify-content-end'>
                <div>
                  <button
                    className='btn btn-sm btn-secondary align-self-center me-2'
                    onClick={resetBankDetail}
                  >
                    Cancel
                  </button>
                  <button
                    className='btn btn-sm btn-primary align-self-center'
                    onClick={updateBankDetail}
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      </FeatureGate>

      <div
        hidden={
          checkRole(['deactivate_account_edit'], roleState.features) === false &&
          paramUserId !== currentUser?.id &&
          paramUserId !== undefined
        }
      >
        {/* SignInMethod component removed - now integrated into UserDetailsTable */}
        {/* {userId === currentUser?.id && <SalaryOverview />} */}
      </div>
    </>
  )
}
export default Overview
